const uris = {
  dev: {
    graphQL: 'http://localhost:1337/graphql',
    rest: 'http://localhost:1337'
  },
  prod: {
    graphQL: 'https://tierlisted-cms.herokuapp.com/graphql',
    rest: 'https://tierlisted-cms.herokuapp.com'
  },
  build: {
    graphQL: 'https://tierlisted-cms.herokuapp.com/graphql',
    rest: 'https://tierlisted-cms.herokuapp.com'
  }
};

const keys = {
  dev: {
    gAnalytics: 'UA-142327644-2',
    gOptimize: '',
    amplitude: '9efe8fe67809a6fb592495952cf47982',
    hotjar: null,
    branch: '',
    fbPixel: '759106037843930'
  },
  prod: {
    gAnalytics: 'UA-142327644-1',
    gOptimize: 'GTM-PMSRZJ6',
    amplitude: '4dd23e8233b592318ca08c68e1cda0df',
    hotjar: '1423787',
    branch: '',
    fbPixel: '2460754857343186'
  }
};

// If running
// locally -> local CMS
// netlify build machine -> build CMS
// hosted user browser -> production CMS

let environments = uris.dev;

if (process.env.NETLIFY_ENV) {
  if (process.env.NETLIFY_ENV === 'production') {
    environments = uris.prod;
  }
  else {
    environments = uris.build;
  }
}
else {
  if (typeof window !== `undefined` && !window.location.host.includes('localhost')) {
    environments = uris.prod;
  }
}

const isProduction = process.env.NETLIFY_ENV && process.env.NETLIFY_ENV === 'production';

const apiKeys = isProduction ? keys.prod : keys.dev;

module.exports = {
  environments,
  apiKeys,
  isProduction
};
